module.exports = __webpack_public_path__ + "img/005-think.1f6f6081.png";